import { useState } from 'react';

export function Process() {
  const steps = [
    {
      n: "01",
      title: "Listen",
      duration: "Week 0 · half a week",
      body: "We start with a long, unhurried conversation. I learn the product, the team, the constraints, the metric that actually matters. No deck.",
      bullets: ["Stakeholder interviews", "Existing audit", "Goal alignment"],
      detail: "Four to six deep interviews with the people closest to the work. Output: a one-page memo of what I heard, in your words.",
    },
    {
      n: "02",
      title: "Frame",
      duration: "Week 1 · 5 days",
      body: "I write the brief back to you in a single page. We argue about it. When the page is right, the design is half done.",
      bullets: ["One-page brief", "Success criteria", "Surface map"],
      detail: "We name the metric, the constraint, the user, the surface. Anything not on the page won't make it into the design.",
    },
    {
      n: "03",
      title: "Sketch",
      duration: "Week 2, 3 · 8 days",
      body: "Low-fi flows, fast. Three to five directions, none of them precious. We pick one to push, two to keep around.",
      bullets: ["Flows", "Wireframes", "Tone studies"],
      detail: "Sketches go up on a wall, digital or otherwise. We discuss tradeoffs in front of them, then commit. Speed matters here.",
    },
    {
      n: "04",
      title: "Make",
      duration: "Week 3, 6 · 4 weeks",
      body: "High-fidelity design, prototype, review on Fridays. The spec is the Figma file, paired with code-aware tokens engineering can use Monday morning.",
      bullets: ["Hi-fi screens", "Prototype", "Tokens"],
      detail: "Friday reviews, 30 minutes each. Decisions are written down. Tokens ship to engineering as JSON, not a screenshot.",
    },
    {
      n: "05",
      title: "Ship",
      duration: "Week 6, 8 · 2 weeks",
      body: "I sit with engineering through QA. Polish passes. Motion specs. We don't call it done until the build looks like the file.",
      bullets: ["QA pairing", "Motion specs", "Hand-off"],
      detail: "I'm in your Slack, your standups, your QA channel. The file and the build converge until you can't tell them apart.",
    },
  ];

  const [active, setActive] = useState(-1);

  return (
    <section id="process" className="process dark">
      <div className="container">
        <div className="process-head">
          <span className="eyebrow" data-reveal><span className="dot"></span>How I work · 8-week sprint</span>
          <h2 className="display process-title" data-reveal style={{ "--reveal-delay": "100ms" }}>
            Five movements,<br />no surprises.
          </h2>
        </div>

        <div className="process-track">
          <div className="process-line">
            <div className="process-line-fill" style={{ width: `${(active / (steps.length - 1)) * 100}%` }} />
          </div>
          <div className="process-steps">
            {steps.map((s, i) => (
              <article
                key={s.n}
                className={`process-step ${i === active ? "active" : ""} ${i < active ? "past" : ""}`}
                data-reveal
                style={{ "--reveal-delay": `${i * 80}ms` }}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                tabIndex={0}
              >
                <div className="process-step-head">
                  <span className="process-step-num">{s.n}</span>
                  <span className="process-step-duration">{s.duration}</span>
                </div>
                <h3 className="display process-step-title">{s.title}</h3>
                <p className="process-step-body">{s.body}</p>
                <ul className="process-step-list">
                  {s.bullets.map((b, j) => (
                    <li key={j}>{b}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
